import { useEffect, useContext } from "react";
import { LoadingContext } from "react-router-loading";
import { TokenVerificationLoggedin, ScreenViewOnboarding, BlockOtherThanAdmin } from "../utils/tokenVerify";
import MyProfileV2 from "./PublisherProfile/MyProfileV2";
import OnboardingMain from "./PublisherProfile/Onboarding/OnboardingMain";

const Onboarding = () => {
  const loadingContext = useContext(LoadingContext);

  useEffect(() => {
    TokenVerificationLoggedin();
    ScreenViewOnboarding();
    BlockOtherThanAdmin();

  }, [])

  return (
    <>
      {/* <MyProfileV2 callFrom="onboarding" /> */}
      <OnboardingMain callFrom="onboarding" />
    </>
  )

};

export default Onboarding;
